"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonV2Service = void 0;
const OpenAPI_1 = require("../core/OpenAPI");
const request_1 = require("../core/request");
class PersonV2Service {
    /**
     * @returns GetPersonsResponse Success
     * @throws ApiError
     */
    static getV2Persons() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/v2/persons',
        });
    }
    /**
     * @param requestBody
     * @returns CreatePersonResponse Success
     * @throws ApiError
     */
    static createV2Person(requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/v2/persons',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @param personId
     * @returns GetPersonResponse Success
     * @throws ApiError
     */
    static getV2Person(personId) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/v2/persons/{personId}',
            path: {
                'personId': personId,
            },
            errors: {
                403: `Unauthorized`,
            },
        });
    }
    /**
     * @param personId
     * @param requestBody
     * @returns UpdatePersonResponse Success
     * @throws ApiError
     */
    static updateV2Person(personId, requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'PUT',
            url: '/v2/persons/{personId}',
            path: {
                'personId': personId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
            },
        });
    }
}
exports.PersonV2Service = PersonV2Service;
